export const SET_ZOHO_INVOICES = 'SET_ZOHO_INVOICES'
export const APPEND_ZOHO_INVOICES = 'APPEND_ZOHO_INVOICES'
export const SET_ZOHO_INVOICES_TOTAL_LENGTH = 'SET_ZOHO_INVOICES_TOTAL_LENGTH'
export const SET_INVOICES_IS_LOADING = 'SET_INVOICES_IS_LOADING'
export const SET_INVOICE_LINK_IS_LOADING = 'SET_INVOICE_LINK_IS_LOADING'
export const SET_INVOICES_IS_NOT_FOUND = 'SET_INVOICES_IS_NOT_FOUND'
export const SET_SHOW_SKELETON_INVOICES = 'SET_SHOW_SKELETON_INVOICES'